import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { AgreementHistory, User } from "models";

type PrivacyAndSecurityStatus = {
  signed: boolean;
  history: AgreementHistory[];
  data_officer: User;
};

const component = "PrivacyAndSecurityDashboard";

export const PrivacyAndSecurityQueryKeys = {
  status: backendQueryKey<PrivacyAndSecurityStatus>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/agreements/privacy/status" })
};
